import { Dimension } from 'src/@enums'

export const BASE_DIMENSIONS: Record<Dimension, string> = {
  [Dimension.RESELLER_SLUG]: 'dimension2',
  [Dimension.PROMO_STATUS]: 'dimension6',
  [Dimension.USER_TYPE]: 'dimension9',
  [Dimension.PROMPT_DELIVERY]: 'dimension12',
  [Dimension.RESELLER_PRICE]: 'dimension18',
  [Dimension.TRANSACTION_ID]: 'dimension21',
  [Dimension.CF_ID]: 'dimension22',
}

export const EUDORA_DIMENSIONS: typeof BASE_DIMENSIONS = {
  ...BASE_DIMENSIONS,
  [Dimension.TRANSACTION_ID]: 'dimension19',
  [Dimension.CF_ID]: 'dimension20',
}
